import { render, staticRenderFns } from "./reviews-slider.vue?vue&type=template&id=34210bd8&scoped=true&"
import script from "./reviews-slider.vue?vue&type=script&lang=js&"
export * from "./reviews-slider.vue?vue&type=script&lang=js&"
import style0 from "./reviews-slider.vue?vue&type=style&index=0&id=34210bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34210bd8",
  null
  
)

export default component.exports